import IReport from './IReport';
import generateCSV from "../../services/CSVController";
import save from 'save-file';
import { toLocalDateTime } from '../../yoello-lib/modules/utils/TimeConversion';

export interface IOrderFeesReport {
  created_on: string;
  venue_id: string;
  venue_name: string;
  order_id: string;
  order_type: string;
  order_status: string;
  item_total: string;
  order_tax: string;
  service_charge: string;
  delivery_charge: string;
  gratuity: string;
  order_total: string;
  transaction_fee_percentage: string;
  transaction_fee_pence: string;
}
export default async function OrderFeesReport(
    reportArray: IOrderFeesReport[] | undefined, 
    reportObj: IReport, 
    venueName: string
  ) {
    
    if (reportArray !== undefined && reportArray.length > 0) {
        const arrayOfKeys = [
          "created_on",
          "venue_id",
          "venue_name",
          "order_id",
          "order_status",
          "order_type",
          "item_total",
          "order_tax",
          "service_charge",
          "delivery_charge",
          "gratuity",
          "order_total",
          "transaction_fee_percentage",
          "transaction_fee_pence",
        ];

        const arrayOfHeaders = [
          "Date/Time",
          "Venue ID",
          "Venue Name",
          "Order ID",
          "Order status",
          "Order type",
          "Item Total",
          "Tax",
          "Service Fee",
          "Delivery Fee",
          "Gratuity",
          "Order Total",
          "Variable Transaction Fee (%)",
          "Fixed Transaction Fee",
        ];

        const mapFeeReport = reportArray.map((feeObject) => {
            return {
                ...feeObject,
                created_on : toLocalDateTime(feeObject.created_on, "DD/MM/YYYY HH:mm"),
            };
        });
        const csvString = generateCSV(mapFeeReport, arrayOfKeys, arrayOfHeaders);
        save(csvString, 
          `${venueName}-order-fees-report-from${
            reportObj.start_date_time
          }to${
            reportObj.end_date_time
          }.csv`
          );
        return;
    }
}